import { createStore, stateSetterHandler } from '@muvi/react-common';
import { isDevtoolsEnabled } from '@/logic/state/store-devtools';

export type CinemaState = {
  selectedCinemas: number[];
};

const initState: CinemaState = {
  selectedCinemas: [],
};

export const useCinemas = createStore({
  name: 'cinemas',
  devtools: isDevtoolsEnabled,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setSelectedCinemas: handler('selectedCinemas'),
  };
});
